import { useCallback, useMemo } from 'react'
import { SendHorizontal } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import { fetchSendConfirm, LEGAL_KIND_OPTS, LEGAL_STR as S, type LegalRow } from './legalFlowApi'

/**
 * A19.11 — Yuborish va tasdiqlash (send & confirm, read-only). Bajarilgan
 * (fulfilled) so'rovlar — javob yuborilgan/tasdiqlangan. GET /admin/legal ustidan
 * (holat POST /admin/legal/:id/status orqali A19.02 kartasida qo'yiladi).
 * Backend yo'q/xato → fail-soft.
 */
export function LegalSendConfirmScreen() {
  const columns = useMemo<AdminColumn<LegalRow>[]>(
    () => [
      { key: 'id', header: S.id, type: 'id', width: 70 },
      { key: 'kind', header: S.kind, type: 'enum', width: 140, options: LEGAL_KIND_OPTS },
      { key: 'authority', header: S.authority, type: 'text', minWidth: 180 },
      { key: 'reference', header: S.reference, type: 'text', width: 150 },
      { key: 'resolution', header: S.resolution, type: 'longtext', minWidth: 200 },
      { key: 'resolved_at', header: S.resolvedAt, type: 'date', width: 160 },
    ],
    [],
  )
  const fetcher = useCallback(fetchSendConfirm, [])
  return (
    <>
      <PageHeader title={S.sendTitle} screenId="A19.11" description={S.sendDesc} />
      <DataTable<LegalRow>
        screenId="A19.11"
        permission={PERMISSIONS.USERS_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => String(r.id)}
        exportable
        emptyState={{ icon: <SendHorizontal size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
